import { addresses } from "@my-app/contracts";

export const protocolModules = {
  aaveDepositSIP: {
    name: "AAVE Deposit SIP",
    contractFunctionSig: "0xe8eda9df",
  },
  uniswapSwapSIP: {
    name: "Uniswap Swap SIP",
    contractFunctionSig: "0x38ed1739",
  },
};

export const CHAINS = {
  Goerli: {
    name: "Goerli",
    shortName: "Goerli",
    image: "Eth",
    tokenName: "Goerli Token",
    symbol: "ETH",
    chainId: 5,
    rpcUrl: "https://goerli.infura.io/v3/53e706eaa088405491d1e311f6a6938b",
    explorer: "https://goerli.etherscan.io/",
    subgraph: "",
  },
  Mumbai: {
    name: "Polygon Mumbai Network",
    shortName: "Mumbai",
    image: "Poly",
    tokenName: "MATIC Token",
    symbol: "MATIC",
    chainId: 80001,
    rpcUrl: "https://rpc.ankr.com/polygon_mumbai",
    explorer: "https://mumbai.polygonscan.com/",
    subgraph: "",
  },
  Optimism: {
    name: "Optimism Goerli",
    shortName: "Optimism",
    image: "Goerli",
    tokenName: "ETH",
    symbol: "ETH",
    chainId: 420,
    rpcUrl: "https://goerli.optimism.io",
    explorer: "https://goerli-optimism.etherscan.io/",
    subgraph: "",
  },
  Skale: {
    name: "Skale Network",
    shortName: "Skale",
    image: "SKALE",
    tokenName: "sFUEL",
    symbol: "sFUEL",
    chainId: 647426021,
    rpcUrl: "https://eth-online.skalenodes.com/v1/hackathon-complex-easy-naos",
    explorer: "https://hackathon-complex-easy-naos.explorer.eth-online.skalenodes.com/",
    subgraph: ""
  },
  Cronos: {
    name: "Cronos Testnet",
    shortName: "Cronos",
    image: "Cronos",
    tokenName: "tCRO",
    symbol: "tCRO",
    chainId: 338,
    rpcUrl: "https://evm-t3.cronos.org",
    explorer: "https://testnet.cronoscan.com/",
    subgraph: ""
  },
  Aurora: {
    name: "Aurora Testnet",
    shortName: "Aurora",
    image: "Aurora",
    tokenName: "ETH",
    symbol: "ETH",
    chainId: 1313161555,
    rpcUrl: "https://testnet.aurora.dev",
    explorer: "https://testnet.aurorascan.dev/",
    subgraph: ""
  },
  Oasis: {
    name: "Oasis Emerald",
    shortName: "Oasis",
    image: "Oasis",
    tokenName: "TEST",
    symbol: "TEST",
    chainId: 42261,
    rpcUrl: "https://testnet.emerald.oasis.dev/",
    explorer: "https://testnet.explorer.emerald.oasis.dev",
    subgraph: ""
  }
};
